import React, { useEffect, useState } from 'react';
import { useForm, SubmitHandler, Controller, set } from 'react-hook-form';
import Input from '../../../components/elements/form/input';
import SelectBox from '../../../components/elements/form/selectBox';
import Button from '../../../components/elements/button';
import toast from 'react-hot-toast';
import { useCommonApi } from '../../../store/api/hooks/commonApiHook';
import { useAppLoader } from '../../../_common/pageLoader/appLoaderHook';
import { getSelectedOption, getSelectedOptions } from '../../../_common/functions';
import FileUpload from '../../../components/elements/form/fileUplaod';
import { Option } from '../../../_config/types';
import { useStatesSelector } from '../../../store/selectors/masterSelector';
import { MAP_KEY } from '../../../_config';
import { LoadScript, Autocomplete } from "@react-google-maps/api";
import { useVendorsApi } from '../../../store/api/hooks/vendorsApiHook';
import { useBillComApi } from '../../../store/api/hooks/billComApiHook';
import Select from "react-select";
import { Link } from 'react-router-dom';
import Loader from '../../../components/loader';

interface Props {
    editID?: any
    onCreate?: () => void
    onCancel?: () => void
    _ref?: any
}

type FormValues = {
    name: string,
    contactPersonName: any,
    contactPersonEmail: any,
    contactPersonPhone: any,
    contactPerson: any,
    addressStreet: any,
    stateID: any,
    cityID: any,
    zipCode: any,
    countyID: any,
    serviceTypeIDs: any,
    InputFile: any,
    billComVendorID: any,
};

const CreateVendor: React.FC<Props> = ({ _ref, editID, onCreate = () => { }, onCancel = () => { } }) => {

    const { showLoader, hideLoader } = useAppLoader()
    const commonApi: any = useCommonApi();
    const vendorApi = useVendorsApi();
    const billComApi = useBillComApi();
    const [editData, setEditData] = useState<any>(null);
    const states: Option[] | null = useStatesSelector();
    const [serviceTypeOption, setServiceTypeOption] = useState<any>(null);
    const [countyoption, setCountyoption] = useState<any>(null);
    const [cityoption, setCityoption] = useState<any>(null);
    const [locations, setLocations] = useState<any>(null);
    const [working, setWorking] = useState<boolean>(false);
    const { control, getValues, reset, setValue, handleSubmit, formState: { errors }, watch } = useForm<FormValues>({
        defaultValues: {
            serviceTypeIDs: [],
            billComVendorID: null,
        },
    });
    const serviceTypeWatch = watch('serviceTypeIDs');
    const [autocomplete, setAutocomplete] = useState<any>(null);
    const [attachments, setAttachments] = useState<any[]>([]);
    const [poattachments, setPoAttachments] = React.useState<FileList | null>(null);
    const [selectedServices, setSelectedServices] = useState<any[]>([]);
    const [serviceTypeLoading, setServiceTypeLoading] = useState(false);
    const [addressLoading, setAddressLoading] = useState(false);
    const [vendorCode, setVendorCode] = useState<string>('');
    const [billComVendorOptions, setBillComVendorOptions] = useState<any[]>([]);
    const [billComVendorLoading, setBillComVendorLoading] = useState(false);


    let imgExt = [".png", ".jpg", ".jpeg", ".webp"];

    const onLoad = (autocomplete: any) => {
        setAutocomplete(autocomplete);
    };

    const changeAttachmentHandler = (e: any) => {
        setPoAttachments(e.target.files);
    };


    useEffect(() => {
        // Always call GetStateList regardless of states value
        commonApi.GetStateList({}, (resp: any) => { }, (error: any) => { });
    }, [])

    const stateWatch = watch('stateID');
    const countyWatch = watch('countyID');

    // Trigger validation when service types change
    useEffect(() => {
        const currentBillComValue = getValues('billComVendorID');
        setValue('billComVendorID', currentBillComValue, { shouldValidate: true });
    }, [serviceTypeWatch, setValue, getValues]);

    const onSubmit: SubmitHandler<FormValues> = data => {
        // Split contactPersonName into FirstName and LastName
        let firstName = '';
        let lastName = '';

        if (data.contactPersonName && typeof data.contactPersonName === 'string') {
            const nameParts = data.contactPersonName.split(',');
            if (nameParts.length === 2) {
                lastName = nameParts[0].trim();
                firstName = nameParts[1].trim();
            }
        }

        let payload: any = {
            "name": data.name,
            "contactPersionName": data.contactPersonName,
            "firstName": firstName,
            "lastName": lastName,
            "contactPersonEmail": data.contactPersonEmail ?? null,
            "contactPersonPhone": data.contactPersonPhone ?? null,
            "contactPerson": data.contactPerson ?? null,
            "addressStreet": data.addressStreet ?? null,
            "cityID": data.cityID?.value ?? null,
            "cityName": data.cityID?.label ?? null,
            "stateID": data.stateID?.value ?? null,
            "stateName": data.stateID?.label ?? null,
            "zipCode": data.zipCode ?? null,
            "countyID": data.countyID?.value ?? null,
            "countyName": data.countyID?.label ?? null,
            "code": editData ? (editData?.code || '') : vendorCode,
            "isSageSynced": editData ? (editData?.isSageSynced || false) : false,
            "sageRecordNo": editData ? (editData?.sageRecordNo || 0) : 0,
            "vendorStatusID": 2,
            "billComVendorID": data.billComVendorID?.value ?? null,
            "serviceTypes": data.serviceTypeIDs?.map((st: any) => {
                return {
                    vendorServiceTypeID: st.value,
                    vendorServiceTypeName: st.label
                };
            }) || []
        }
        if (editID) {
            payload['vendorID'] = editID
        }
        showLoader();
        setWorking(true);
        vendorApi.SaveVendorDetails(payload, (resp: any) => {
            console.log('update check image', !Array.isArray(data?.InputFile), data?.InputFile);
            if (typeof data?.InputFile == 'object' && !Array.isArray(data?.InputFile) && data?.InputFile) {
                const formData = new FormData();
                formData.append('InputFile', data.InputFile);
                formData.append('VendorID', editID ? editID : resp?.returnID);
                vendorApi.SaveVendorFiles(formData, (resp: any) => {
                    toast.success(resp?.message)
                    onCreate();
                    formReset();
                    hideLoader();
                    setWorking(false);
                    setEditData(null);
                }, (error: any) => {
                    hideLoader();
                    toast.error(error);
                    setWorking(false);
                });
            } else {
                toast.success(resp?.message)
                onCreate();
                formReset();
                hideLoader();
                setWorking(false);
                setEditData(null);
            }

        }, (error: any) => {
            hideLoader();
            toast.error(error);
            setWorking(false);
        });
    };

    // ---- Async version of county fetch ----
    const getCountyList = async (_StateId: any) => {
        return new Promise((resolve, reject) => {
            const payload = { StateId: _StateId };
            commonApi.GetCountyList(
                payload,
                (resp: any) => {
                    let countylistoption: any = resp?.countyList?.map((countylist: any) => ({
                        label: countylist.countyName,
                        value: countylist.cuntyID,
                    }));
                    setCountyoption(countylistoption);

                    if (editData) {
                        const countyOpt = getSelectedOption(editData.countyID, countylistoption, "value");
                        if (countyOpt) setValue("countyID", countyOpt);
                    }

                    if (locations?.county) {
                        const countyOpt = getSelectedOption(locations.county, countylistoption, "label");
                        if (countyOpt) setValue("countyID", countyOpt);
                    }

                    resolve(countylistoption);
                },
                (error: any) => {
                    setLocations(null);
                    reject(error);
                }
            );
        });
    };

    // ---- Async version of city fetch ----
    const getcityList = async (_CountyId: any, _StateId?: any) => {
        return new Promise((resolve, reject) => {
            const payload = {
                StateId: _StateId ? _StateId : getValues("stateID")?.value,
                CountyId: _CountyId,
            };
            commonApi.GetCityList(
                payload,
                (resp: any) => {
                    let citylistoption: any = resp?.cityList?.map((city: any) => ({
                        label: city.cityName,
                        value: city.cityID,
                    }));
                    setCityoption(citylistoption);

                    if (editData) {
                        const cityOpt = getSelectedOption(editData.cityID, citylistoption, "value");
                        if (cityOpt) setValue("cityID", cityOpt);
                    }

                    if (locations?.city) {
                        const cityOpt = getSelectedOption(locations.city, citylistoption, "label");
                        if (cityOpt) setValue("cityID", cityOpt);
                    }

                    resolve(citylistoption);
                },
                (error: any) => {
                    setLocations(null);
                    reject(error);
                }
            );
        });
    };


    // Load initial data unconditionally on component mount
    useEffect(() => {
        // Load city list unconditionally 
        getcityList(null); // Pass null to load cities without county restriction
    }, [states])

    const formReset = () => {
        setWorking(false);
        setEditData(null);
        setLocations(null);
        setVendorCode('');
        reset({
            name: '',
            contactPersonName: '',
            contactPersonEmail: '',
            contactPersonPhone: '',
            contactPerson: '',
            addressStreet: '',
            stateID: null,
            cityID: null,
            zipCode: '',
            InputFile: null,
            countyID: null,
            serviceTypeIDs: [],
            billComVendorID: null
        });
    }

    const getVendorData = () => {
        const payload = {
            vendorID: editID
        };
        vendorApi.GetVendorByID(payload, (resp: any) => {
            setEditData(resp);
        }
            , (error: any) => {
                toast.error(error);
            }
        );
    }
    const getVendorAttachment = () => {
        const payload = {
            vendorID: editID
        };
        vendorApi.GetVendorAttachment(payload, (resp: any) => {
            setAttachments(resp?.vendorFileList || []);
        }
            , (error: any) => {
                toast.error(error);
            }
        );
    }
    const getServiceType = (search: string = ""): Promise<any[]> => {
        return new Promise((resolve, reject) => {
            const payload = {
                searchParam: search
            };
            setServiceTypeLoading(true);
            vendorApi.GetServiceType(payload, (resp: any) => {
                let serviceTypeOption: any = resp?.serviceTypeList?.map((st: any) => {
                    return {
                        label: st.name,
                        value: st.vendorServiceTypeID,
                    }
                });
                setServiceTypeOption(serviceTypeOption);
                setServiceTypeLoading(false);
                resolve(serviceTypeOption);
            }, (error: any) => {
                toast.error(error);
                setServiceTypeLoading(false);
                reject(error);
            });
        });
    };

    const getVendorCode = () => {
        vendorApi.GetVendorCode({}, (resp: any) => {
            setVendorCode(resp?.code || '');
        }, (error: any) => {
            toast.error(error);
        });
    };

    const getBillComVendors = (search: string = "") => {
        const payload = {
            isLinked: 0,
            searchParam: search,
            pageSize:0
        };
        setBillComVendorLoading(true);
        billComApi.getBillComVendors(payload, (resp: any) => {
            const vendorOptions = resp?.results?.map((vendor: any) => ({
                label: vendor.name,
                value: vendor.id,
            })) || [];
            setBillComVendorOptions(vendorOptions);
            setBillComVendorLoading(false);
        }, (error: any) => {
            toast.error(error);
            setBillComVendorLoading(false);
        });
    };


    useEffect(() => {
        if (stateWatch) {
            setValue('countyID', null)
            setValue('cityID', null)
            getCountyList(stateWatch.value)
        }
    }, [stateWatch])

    useEffect(() => {
        if (countyWatch) {
            setValue('cityID', null)
            getcityList(countyWatch.value, stateWatch?.value)
        }
    }, [countyWatch])


    useEffect(() => {
        if (_ref?.current) {
            _ref.current.reset = formReset;
        }
    }, [_ref])

    const onPlaceChanged = async () => {
        if (autocomplete !== null) {
            const place = autocomplete.getPlace();

            let state = place.address_components.find((a: any) => a.types.includes("administrative_area_level_1"))?.short_name;
            let city = place.address_components.find((a: any) => a.types.includes("locality"))?.short_name;
            let county = place.address_components.find((a: any) => a.types.includes("administrative_area_level_2"))?.short_name?.replace("County", "")?.trim();
            let zip = place.address_components.find((a: any) => a.types.includes("postal_code"))?.short_name;

            setLocations({ state, city, county, zip });

            if (state) {
                const stateOption = states?.find((item: any) => item.data.shortName === state);
                if (stateOption) {
                    setValue("stateID", stateOption);

                    setAddressLoading(true);
                    try {
                        const countyOpts: any = await getCountyList(stateOption.value);

                        if (county && countyOpts?.length) {
                            const countyOption = getSelectedOption(county, countyOpts, "label");
                            if (countyOption) {
                                setValue("countyID", countyOption);

                                const cityOpts: any = await getcityList(countyOption.value, stateOption.value);

                                if (city && cityOpts?.length) {
                                    const cityOption = getSelectedOption(city, cityOpts, "label");
                                    if (cityOption) setValue("cityID", cityOption);
                                }
                            }
                        }
                    } finally {
                        setAddressLoading(false);
                    }
                }
            }

            if (zip) setValue("zipCode", zip);
            setValue("addressStreet", place.formatted_address);
        }
    };


    useEffect(() => {
        if (editID) {
            getVendorData();
        } else {
            formReset();
        }
    }, [editID])

    // Get vendor code only on initial load for new vendor
    useEffect(() => {
        if (!editID) {
            getVendorCode();
        }
    }, [])

    // Load Bill.com vendors unconditionally on component mount
    useEffect(() => {
        getBillComVendors();
    }, []);

    // Load service types unconditionally on component mount
    useEffect(() => {
        getServiceType("");
    }, []);

    // Load counties unconditionally on component mount
    useEffect(() => {
        // Load counties for a default state if available
        if (states && states.length > 0) {
            getCountyList(states[0]?.value);
        }
    }, [states]);

    useEffect(() => {
        if (editData && cityoption?.length) {
            const cityOpt = getSelectedOption(editData.cityID, cityoption, "value");
            if (cityOpt) setValue("cityID", cityOpt);
        }
    }, [editData, cityoption, setValue]);


    useEffect(() => {
        if (editData && countyoption?.length) {
            const countyOpt = getSelectedOption(editData.countyID, countyoption, "value");
            if (countyOpt) setValue("countyID", countyOpt);
        }
    }, [editData, countyoption, setValue]);

    useEffect(() => {
        if (editData) {
            setAddressLoading(true);
            const initForm = async () => {
                // Handle contact person name - combine firstName and lastName if available, otherwise use existing contactPersionName
                let contactPersonName = editData.contactPersionName;
                if (editData.lastName && editData.firstName) {
                    contactPersonName = `${editData.lastName}, ${editData.firstName}`;
                }

                reset({
                    name: editData.vendorName,
                    contactPersonName: contactPersonName,
                    contactPersonEmail: editData.contactPersonEmail,
                    contactPersonPhone: editData.contactPersonPhone,
                    contactPerson: editData.contactPerson,
                    addressStreet: editData.addressStreet,
                    zipCode: editData.zipCode,
                    billComVendorID: editData.billComVendorID ? {
                        value: editData.billComVendorID,
                        label: editData.billComVendorName || editData.billComVendorID
                    } : null,
                });

                // Set vendor code from editData
                setVendorCode(editData.vendorCode || '');

                const initial = editData.serviceTypes?.map((st: any) => ({
                    value: st.vendorServiceTypeID,
                    label: st.vendorServiceTypeName,
                })) || [];
                setSelectedServices(initial);
                setValue("serviceTypeIDs", initial);
                if (editData.stateID) {
                    const stateOption = getSelectedOption(editData.stateID, states as any);
                    setValue("stateID", stateOption);

                    const countyOpts: any = await getCountyList(editData.stateID);

                    if (editData.countyID) {
                        await getcityList(editData.countyID, editData.stateID);
                        setValue(
                            "cityID",
                            getSelectedOption(editData.cityID, cityoption as any)
                        );
                    }
                }

                setAddressLoading(false);
            };

            initForm();
        } else {
            formReset();
        }
    }, [editData, reset]);


    return (
        <div className={`relative`}>
            {/* {addressLoading && (
                <div className={`absolute p-8`} style={{ height: "100%", width: "100%", zIndex: 2, backgroundColor: "rgba(255, 255, 255, 0.5)" }}>
                    <Loader />
                </div>
            )} */}
            <form onSubmit={handleSubmit(onSubmit)} ref={_ref} className={`flex-col`}>
                <div className='flex-1 overflow-auto'>
                    <h4 className='font-semibold text-[0.938rem] pb-1 uppercase'>Details</h4>
                    <Controller
                        name='name'
                        control={control}
                        rules={{ required: 'Vendor name is required' }}
                        render={({ field: { value, onChange } }) => (
                            <Input
                                label='Name'
                                type='text'
                                value={value}
                                onChange={onChange}
                                required
                                placeholder='Write Vendor Name Here'
                                error={errors.name?.message}
                            />
                        )}
                    />

                    <h4 className='font-semibold text-[0.938rem] pb-1 uppercase'>Contact Information</h4>
                    <div className='grid grid-cols-2 gap-x-2 gap-y-0 [&>*]:mb-0'>
                        <Controller
                            name='contactPersonName'
                            control={control}
                            rules={{
                                pattern: {
                                    value: /^[A-Za-z\s]+,\s*[A-Za-z\s]+$/,
                                    message: "Please enter name in format: Last name, First Name (e.g. Rees, Michelle)"
                                },
                                validate: (value) => {
                                    if (!value) return true; // Allow empty value
                                    const commaCount = (value.match(/,/g) || []).length;
                                    if (commaCount === 0 && value.trim() !== '') {
                                        return "Please use format: Last name, First Name (e.g. Rees, Michelle)";
                                    }
                                    return true;
                                }
                            }}
                            render={({ field: { value, onChange } }) => (
                                <Input
                                    label='Contact Person Name (e.g. Rees, Michelle)'
                                    type='text'
                                    value={value}
                                    onChange={(e: any) => {
                                        const input = e.target.value;
                                        // Count existing commas
                                        const commaCount = (input.match(/,/g) || []).length;
                                        // Only allow input if it doesn't result in more than 1 comma
                                        if (commaCount <= 1) {
                                            onChange(input);
                                        }
                                    }}
                                    placeholder='format: Last name, First Name'
                                    error={errors.contactPersonName?.message as any}

                                />
                            )}
                        />
                        <Controller
                            name='contactPersonEmail'
                            control={control}
                            render={({ field: { value, onChange } }) => (
                                <Input
                                    label='Email'
                                    type='email'
                                    value={value}
                                    onChange={onChange}
                                    placeholder='Contact Person Email'
                                    error={errors.contactPersonEmail?.message as any}
                                />
                            )}
                        />

                        <Controller
                            name="contactPersonPhone"
                            control={control}
                            rules={{
                                pattern: {
                                    value: /^(\d{3}-\d{3}-\d{4}|\d{10})$/,
                                    message: "Enter a valid phone number (XXX-XXX-XXXX or XXXXXXXXXX)"
                                }
                            }}
                            render={({ field: { value, onChange } }) => (
                                <Input
                                    label="Phone"
                                    type="text"
                                    value={value}
                                    onChange={(e: any) => {
                                        const input = e.target.value;
                                        // Allow digits and hyphens only
                                        const formatted = input.replace(/[^\d-]/g, "");
                                        onChange(formatted);
                                    }}
                                    maxLength={12}
                                    placeholder="xxx-xxx-xxx or xxxxxxxxxx"
                                    error={errors.contactPersonPhone?.message as any}
                                />
                            )}
                        />
                        <Controller
                            name="contactPerson"
                            control={control}
                            rules={{
                                pattern: {
                                    value: /^(\d{3}-\d{3}-\d{4}|\d{10})$/,
                                    message: "Enter a valid Mobile number (XXX-XXX-XXXX or XXXXXXXXXX)"
                                }
                            }}
                            render={({ field: { value, onChange } }) => (
                                <Input
                                    label="Mobile"
                                    type="text"
                                    value={value}
                                    onChange={(e: any) => {
                                        const input = e.target.value;
                                        // Allow digits and hyphens only
                                        const formatted = input.replace(/[^\d-]/g, "");
                                        onChange(formatted);
                                    }}
                                    maxLength={12}
                                    placeholder="xxx-xxx-xxx or xxxxxxxxxx"
                                    error={errors.contactPerson?.message as any}
                                />
                            )}
                        />
                    </div>
                    <h4 className='font-semibold text-[0.938rem] pb-1 pt-4 uppercase'>Address</h4>

                    <div className="relative">
                        {addressLoading && (
                            <div className="absolute inset-0 bg-white/70 flex items-center justify-center z-10">
                                <Loader />
                            </div>
                        )}
                        <LoadScript googleMapsApiKey={MAP_KEY} libraries={['places']}>
                            {/* Street */}
                            <Controller
                                name="addressStreet"
                                control={control}
                                render={({ field: { value, onChange } }) => (
                                    <div className="w-full">
                                        <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
                                            <Input
                                                label="Street"
                                                type="text"
                                                value={value}
                                                onChange={onChange}
                                                placeholder="Write Street Address Here"
                                                error={errors?.addressStreet?.message as any}
                                            />
                                        </Autocomplete>
                                    </div>
                                )}
                            />
                        </LoadScript>

                        <div className="grid grid-cols-3 gap-x-2 gap-y-0 [&>*]:mt-0 [&>*]:mb-0">
                            {/* City */}
                            <Controller
                                name="cityID"
                                control={control}
                                render={({ field: { value, onChange } }) => (
                                    <SelectBox
                                        label="City"
                                        value={value}
                                        onChange={onChange}
                                        placeholder="Choose City"
                                        options={cityoption ? cityoption : []}
                                        error={errors.cityID?.message as any}
                                    />
                                )}
                            />
                            <Controller
                                name='stateID'
                                control={control}
                                render={({ field: { value, onChange } }) => (
                                    <SelectBox
                                        label='State'
                                        value={value}
                                        onChange={onChange}

                                        placeholder='Choose State'
                                        options={states ? states : []}
                                        error={errors.stateID?.message as any}
                                    />
                                )}
                            />
                            <Controller
                                name='zipCode'
                                control={control}
                                render={({ field: { value, onChange } }) => (
                                    <Input
                                        label='Zip Code'
                                        type='text'
                                        value={value}
                                        onChange={onChange}
                                        placeholder='Write Zip Code Here'
                                        error={errors.zipCode?.message as any}
                                    />
                                )}
                            />
                        </div>
                    </div>

                    <Controller
                        name="serviceTypeIDs"
                        control={control}
                        render={({ field: { onChange } }) => (
                            <div className="flex flex-col pt-4">
                                <label className="mb-1 font-normal text-[0.938rem] leading-none">
                                    Service Type
                                </label>

                                
                                <div className="flex flex-wrap gap-2 mb-2">
                                    {selectedServices.map((v: any) => (
                                        <span
                                            key={v.value}
                                            className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm"
                                        >
                                            {v.label}
                                            <button
                                                type="button"
                                                className="ml-1 text-red-500"
                                                onClick={() => {
                                                    const updated = selectedServices.filter((item) => item.value !== v.value);
                                                    setSelectedServices(updated);
                                                    onChange(updated);
                                                }}
                                            >
                                                ✕
                                            </button>
                                        </span>
                                    ))}
                                </div>

                                
                                <Select isMulti
                                    components={{ MultiValue: () => null }} placeholder="Choose Service Type"
                                    value={[]} menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        menuList: (base) => ({
                                            ...base,
                                            maxHeight: 150,
                                            overflowY: "auto",
                                            scrollbarWidth: "none",
                                            msOverflowStyle: "none",
                                            "::-webkit-scrollbar": { display: "none", },
                                        }),
                                    }}
                                    onChange={(newVal) => {
                                        const merged = [...selectedServices];
                                        newVal.forEach((nv: any) => {
                                            if (!merged.some((m) => m.value === nv.value)) {
                                                merged.push(nv);
                                            }
                                        });
                                        setSelectedServices(merged);
                                        onChange(merged);
                                    }}
                                    onInputChange={(inputValue) => {
                                        if (inputValue.length >= 2) {
                                            getServiceType(inputValue);
                                        } else if (inputValue === "") {
                                            getServiceType("");
                                        }
                                    }}
                                    options={serviceTypeOption || []}
                                    isLoading={serviceTypeLoading}
                                />

                            </div>
                        )}
                    />

                    <Controller
                        name='billComVendorID'
                        control={control}
                        rules={{
                            validate: (value) => {
                                const selectedServiceTypes = getValues('serviceTypeIDs');
                                const serviceType6 = selectedServiceTypes?.find((service: any) =>
                                    service.value === 6 || service.value === "6"
                                );

                                if (serviceType6 && (!value || !value.value)) {
                                    return `Bill.com VendorID is required when Service Type with ${serviceType6.label} is selected`;
                                }
                                return true;
                            }
                        }}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label='Bill.com VendorID'
                                value={value}
                                onChange={onChange}
                                placeholder='Choose Bill.com Vendor'
                                options={billComVendorOptions}
                                error={errors.billComVendorID?.message as any}
                                required={serviceTypeWatch?.some((service: any) => service.value === 6 || service.value === "6")}
                            />
                        )}
                    />

                    <Controller
                        name="InputFile"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <FileUpload
                                label="Upload Picture"
                                value={value}
                                isMulti={true}
                                accept=".jpg, .jpeg, .png"
                                isFigmaType={true}
                                allowedExt={[`png`, `jpg`, `jpeg`, `gif`]}
                                retainFiles={true}
                                onChange={(e: any, files: any) => {
                                    changeAttachmentHandler(e);
                                    onChange(e.target.files[0]);
                                }}
                                placeholder="Choose Processing Facility"
                            />
                        )}
                    />
                    {attachments && attachments.length > 0 && (() => {
                        // keep only valid files
                        const validFiles = attachments.filter((item: any) => item.originalFileName != null);

                        if (validFiles.length === 0) return null;

                        return (
                            <div>
                                <h4 className="font-semibold text-[0.938rem] pb-1 uppercase">Files</h4>
                                <div className="grid grid-cols-5 gap-3">
                                    {validFiles.map((item: any, index: number) => {
                                        const found = imgExt.some((word) =>
                                            item.originalFileName?.includes(word)
                                        );

                                        return (
                                            <div
                                                key={`attachmentList${index}`}
                                                className="border border-primary rounded-md flex px-2 py-2 text-[0.813rem] text-primary text-center justify-center items-center relative"
                                            >
                                                <Link to={item.fullFilePath} target="_blank">
                                                    {found ? (
                                                        <img
                                                            src={item.fullFilePath}
                                                            alt={item.originalFileName}
                                                            className="max-w-full max-h-20"
                                                        />
                                                    ) : (
                                                        item.originalFileName
                                                    )}
                                                </Link>
                                                {/* <span className='text-sm text-gray-400 inline-block ms-1'>({item.fileSize})</span> */}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        );
                    })()}


                </div>
                <div className='flex justify-end gap-2 flex-shrink-0 border-t border-gray-200 pt-2'>
                    <Button type="button" theme='secondary' onClick={() => {
                        setEditData(null);
                        formReset();
                        onCancel();
                    }}>Cancel</Button>
                    <Button type="submit" working={working}>Save</Button>
                </div>
            </form>
        </div>
    );
};

export default CreateVendor;